import { FormHeaderAndTabbedContent } from '@strata/react-form-header-and-content';
import { PageTitle } from '@strata/react-page-title';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router';

import { OrtfInboundOverviewTab } from './OrtfInboundOverviewTab';
import { OrtfOutboundFilesTab } from './OrtfOutboundFilesTab';
import { OrtfOutboundFilesTabV2 } from './OrtfOutboundFilesTabV2';
import { OrtfRemainingTransfersTabV2 } from './OrtfRemainingTransfersTabV2';
import { OrtfSentFilesTab } from './OrtfSentFilesTab';

import { AppRoutes } from 'services/routes';
import { useGetLatestRemainingTransfersBatchQuery } from 'store/api/ndpApi';

export const OrtfProcessingPage = () => {
    const { showOrtfToolInAgora = false, showOrtfToolV2 = false } = useFlags();
    const [generatedPlan, setGeneratedPlan] = useState(undefined);
    const [generatedRemainingTransfersBreakdown, setGeneratedRemainingTransfersBreakdown] =
        useState();
    const {
        data: latestRemainingTransfersBatch,
        isFetching: isFetchingLatestRemainingTransfersBatch,
    } = useGetLatestRemainingTransfersBatchQuery(undefined, { skip: !showOrtfToolV2 });
    const location = useLocation();
    const navigate = useNavigate();

    const remainingTransfersBreakdown =
        generatedRemainingTransfersBreakdown ?? latestRemainingTransfersBatch?.breakdown;
    const remainingTransfersId =
        generatedPlan?.remainingTransfersId ?? latestRemainingTransfersBatch?.remainingTransfersId;
    const isLoadingRemainingTransfers =
        !generatedRemainingTransfersBreakdown && isFetchingLatestRemainingTransfersBatch;

    if (!showOrtfToolInAgora) {
        return <Navigate replace to={AppRoutes.home} />;
    }

    const tabs = [
        {
            className: 'ortf-tabbed-grid-content',
            mainContent: showOrtfToolV2 ? (
                <OrtfOutboundFilesTabV2
                    generatedPlan={generatedPlan}
                    onGeneratedPlanChange={setGeneratedPlan}
                    onRemainingTransfersBreakdownChange={setGeneratedRemainingTransfersBreakdown}
                />
            ) : (
                <OrtfOutboundFilesTab />
            ),
            title: showOrtfToolV2 ? 'File Processing' : 'Outbound Files',
        },
    ];

    if (showOrtfToolV2) {
        tabs.push({
            className: 'ortf-tabbed-grid-content',
            mainContent: (
                <OrtfRemainingTransfersTabV2
                    isLoading={isLoadingRemainingTransfers}
                    remainingTransfersBreakdown={remainingTransfersBreakdown}
                    remainingTransfersId={remainingTransfersId}
                />
            ),
            title: 'Remaining Transfers',
        });
    }

    tabs.push({
        className: 'ortf-tabbed-grid-content',
        mainContent: <OrtfSentFilesTab />,
        title: 'Sent Files',
    });

    if (showOrtfToolV2) {
        tabs.push({
            mainContent: <OrtfInboundOverviewTab />,
            title: 'Inbound History',
        });
    }

    return (
        <FormHeaderAndTabbedContent
            rowOneContentHeader={<PageTitle title="ORTF Processing" />}
            activeTab={location.hash.replace(/^#/, '').replace(/-/g, ' ')}
            onTabSelect={(tab) =>
                navigate(
                    {
                        ...location,
                        hash: tab.replace(/\s/g, '-').toLocaleLowerCase(),
                    },
                    { state: location.state, replace: true },
                )
            }
            tabs={tabs}
        />
    );
};
